<script>
import {ModalsContainer} from 'vue-final-modal'
import Modal from "$vueCommon/components/Modal.vue";
import CheckoutAPI from "$vueCommon/classes/API/CheckoutAPI.js";
import {ToastMessageDanger} from "$vueCommon/classes/ToastMessage.js";
import CartItems from "./Cart/CartItems.vue";
import CartSummary from "./Cart/CartSummary.vue";
import bus from 'vue3-eventbus';
import CurrencyAPI from "../classes/API/CurrencyAPI.js";
import CountryAPI from "$vueCommon/classes/API/CountryAPI.js";
import Toast from "$vueCommon/components/Toast.vue";
import Payments from "$vueCommon/components/Cart/Payments.vue";
import BillingData from "$vueCommon/components/Cart/BillingData.vue";
import StickyElement from "$vueCommon/classes/StickyElement.js";
import Price from "$vueCommon/components/Price.vue";
import frontendImgCartLoader from '$frontend/img/cart-loader.svg';
import frontendImgCartEmpty from '$frontend/img/cart-empty.svg';
import PaymentComplete from "$vueCommon/components/Cart/PaymentComplete.vue";
import CartAPI from "$vueCommon/classes/API/CartAPI.js";

export default {
    components: {
        PaymentComplete, Price, BillingData, Toast, Modal, CartSummary, CartItems, ModalsContainer, Payments
    },
    mounted() {
        if (typeof (manager) !== 'undefined') {
            CheckoutAPI.setManagerBaseUrl();
            this.manager = true;
        }

        Promise.all([CheckoutAPI.settings(), CurrencyAPI.info(), CountryAPI.getCountries()]).then(values => {
            this.refreshIdentities(values[0].identities);

            this.items = values[0].cart_content || [];
            this.cartSummary = values[0].cart_summary;
            this.discountCode = values[0].discount_code;
            this.dnsProfiles = values[0].dns_profiles;
            this.payments = values[0].payments;

            if (typeof (cartUrl) !== 'undefined') {
                this.cartUrl = cartUrl;
            }

            if (typeof (checkoutUrl) !== 'undefined') {
                this.checkoutUrl = checkoutUrl;
            }

            this.identities.forEach(identity => {
                if (values[0].billing_user_identity_id && values[0].billing_user_identity_id === identity.id) {
                    this.billingIdentityId = identity.id;
                }
            });

            if (!this.billingIdentityId && this.identities[0]) {
                this.billingIdentityId = this.identities[0].id;
            }

            this.payments.forEach(payment => {
                if (payment.slug === values[0].payment_method) {
                    payment.selected = true;
                }
            });

            if (this.dnsProfiles && this.dnsProfiles.length > 0) {
                this.items.forEach(item => {
                    if (item.associate !== 'Domain') {
                        return;
                    }

                    if (!item.options.user_dns_profile_id) {
                        this.setDomainDnsProfile(item, {dnsProfile: this.dnsProfiles[0]}, true);
                    }
                });
            }

            this.items.forEach(item => {
                if (item.associate !== 'Domain') {
                    return;
                }

                if (!item.options || !item.options.registrant_user_identity_id || !this.userIdentityExists(item.options.registrant_user_identity_id)) {
                    if (this.identities[0]) {
                        this.setDomainIdentity(item, {identity: this.identities[0]}, true);
                    }
                }
            })

            if (!this.hasFilledAccount()) {
                this.forceFirstAdd = true;
            }

            this.ready = true;

            this.sendGTMEvent('begin_checkout');
        });

        bus.on('refreshCart', event => {
            console.log('refreshCart payload', event);
            this.refreshCart(event);
        });

        bus.on('refreshIdentities', event => {
            this.refreshIdentities(event);
        });

        bus.on('refreshIdentity', event => {
            this.refreshIdentity(event);
        });

        bus.on('refreshDnsProfile', event => {
            this.refreshDnsProfile(event);
        });

        bus.on('domainIdentitySelected', event => {
            this.setDomainsIdentities(event);
        });

        bus.on('domainDnsProfileSelected', event => {
            this.setDomainsDnsProfiles(event);
        });

        bus.on('restrictionsAcceptedChanged', event => {
            this.verifyDomainRequirements(event);
        });
    },
    updated() {
        StickyElement.create('.sticky-element')
    },
    methods: {
        refreshCart(event) {
            const itemsOld = this.getDomains().map(item => Object.assign({}, item));

            if (event.rowId) {
                for (let i in this.items) {
                    if (this.items[i].rowId === event.rowId) {
                        let rowFound = false;
                        event.data.cart_content.forEach(cartItem => {
                            if (cartItem.rowId === event.rowId) {
                                rowFound = true;
                                cartItem.showDetails = this.items[i].showDetails;
                                this.items[i] = cartItem;
                            }
                        })
                        if (!rowFound) {
                            this.items.splice(i, 1);
                        }
                    }
                }
            } else {
                this.items = event.data.cart_content;
            }

            for (let domain of this.getDomains()) {
                itemsOld.forEach(itemOld => {
                    if (itemOld.rowId !== domain.rowId) {
                        return;
                    }
                    if (!domain.options) {
                        domain.options = {};
                    }
                    // Przywróć stan checkboxa restrykcji
                    domain.options.restrictions_accepted = itemOld.options.restrictions_accepted;
                    domain.errors = itemOld.errors;
                });

                if (event.verifyDomainRequirements && event.verifyDomainRequirements.rowId === domain.rowId) {
                    this.verifyDomainRequirements(domain, event.verifyDomainRequirements.type);
                }
            }

            this.cartSummary = event.data.cart_summary;
            this.discountCode = event.data.discount_code;
        },
        refreshIdentities(event) {
            this.identities = event;
        },
        refreshIdentity(event) {
            let identityRefreshed = false;

            for (let i = 0; i < this.identities.length; i++) {
                const current = this.identities[i];

                if (
                    current.id === event.id ||
                    (current.id === null && event.id === null)
                ) {
                    Object.assign(current, event);
                    identityRefreshed = true;
                    break;
                }
            }

            if (!identityRefreshed) {
                this.identities.push(event);
            }
        },
        refreshDnsProfile(event) {
            let dnsProfileRefreshed = false;
            for (let i in this.dnsProfiles) {
                if (event.id === this.dnsProfiles[i].id) {
                    this.dnsProfiles[i] = event;
                    dnsProfileRefreshed = true;
                }
            }
            if (!dnsProfileRefreshed) {
                this.dnsProfiles.push(event);
            }
        },
        setDomainsIdentities(domainItemEvent) {
            this.items.forEach(cartItem => {
                if (cartItem.associate === 'Domain' && cartItem.rowId !== domainItemEvent.rowId && domainItemEvent.sameDomain === true) {
                    this.setDomainIdentity(cartItem, domainItemEvent);
                }
            });
        },
        setDomainIdentity(cartItem, domainItemEvent, omitValidation = false) {
            if (cartItem.associate !== 'Domain') {
                return;
            }
            if (cartItem.options.registrant_user_identity_id === domainItemEvent.identity.id) {
                if (!omitValidation) {
                    this.verifyDomainRequirements(cartItem, 'identity');
                }
                console.log(`Domain ${cartItem.name} Identity not changed => skip setting Identity`, cartItem.rowId, domainItemEvent);
                return;
            }
            this.cartItemsSaving[cartItem.rowId] = true;
            CheckoutAPI.postDomainRegistrantUserIdentity(cartItem.rowId, domainItemEvent.identity, omitValidation).then(response => {
                this.cartItemsSaving[cartItem.rowId] = false;
            });
        },
        setDomainsDnsProfiles(domainDnsProfileEvent) {
            this.items.forEach(cartItem => {
                if (cartItem.rowId !== domainDnsProfileEvent.rowId && domainDnsProfileEvent.sameDnsProfiles === true) {
                    this.setDomainDnsProfile(cartItem, domainDnsProfileEvent);
                }
            });
        },
        setDomainDnsProfile(cartItem, domainDnsProfileEvent) {
            if (cartItem.options.user_dns_profile_id === domainDnsProfileEvent.dnsProfile.id) {
                console.log(`domain ${cartItem.name} DNS profile not changed => skip setting DNS profile`);
                return;
            }
            this.cartItemsSaving[cartItem.rowId] = true;
            CheckoutAPI.postUserDomainDnsProfile(cartItem.rowId, domainDnsProfileEvent.dnsProfile).then(response => {
                this.cartItemsSaving[cartItem.rowId] = false;
            });
        },
        setBillingIdentity(identity) {
            this.savingBillingIdentity = true;
            this.billingIdentityId = identity ? identity.id : null;

            CheckoutAPI.postBillingUserIdentity(identity).then(response => {
                this.savingBillingIdentity = false;
                this.verifyBillingData();

                if (!response.billing_user_identity_id) {
                    return;
                }

                const matched = this.identities.find(
                    i => i.id === response.billing_user_identity_id
                );

                if (matched) {
                    this.billingIdentityId = matched.id;
                }
            });
        },
        onBillingEdited(identityId) {
            const identity = this.identities.find(i => i.id === identityId);

            if (identity) {
                this.setBillingIdentity(identity);
            } else {
                this.verifyBillingData();
            }
        },
        verifyBillingData() {
            this.orderErrors.billingData = [];
            if (!this.billingIdentity) {
                this.orderErrors.billingData.push(this.$translate('checkout.provide_billing_data'));
            } else {
                let validation = this.verifyIdentity(this.billingIdentity);
                if (validation !== true) {
                    this.orderErrors.billingData = ['<strong>' + this.$translate('checkout.billing_data') + ':</strong> ' + Object.values(validation).join(', ')];
                }
            }

            if (this.orderErrors.billingData.length === 0) {
                delete this.orderErrors.billingData;
            }
        },
        hasFilledAccount() {
            if (!this.identities || !this.identities.length) {
                return false;
            }

            const required = [
                'first_name',
                'last_name',
                'address',
                'district',
                'postal_code',
                'city',
                'phone',
                'email',
            ];

            return this.identities.some(identity => {
                if (!identity.country_id) {
                    return false;
                }

                for (const field of required) {
                    const value = identity[field];

                    if (!value || value.toString().trim() === '') {
                        return false;
                    }
                }

                return true;
            });
        },
        getIdentityById(identityId = null) {
            return this.identities.find(identity => identity.id === identityId || identity.id === null && identityId === null);
        },
        async payNow() {
            if (this.placingOrder) {
                return;
            }

            this.payNowExecuted = true;
            this.orderErrors = {};

            this.placingOrder = true;

            try {
                if (!Array.isArray(this.items) || this.items.length === 0) {
                    ToastMessageDanger.emit(this.$translate('checkout.your_cart_is_empty'));

                    return;
                }

                // 1. Walidacja domen
                const hasItemErrors = this.verifyDomainsRequirements();

                // 1.5. Jeśli mamy inline formularz billingowy (firstAdd) – spróbuj go zapisać
                let billingSaved = true;
                if (this.$refs.billingData && typeof this.$refs.billingData.validateAndSaveForPayNow === 'function') {
                    billingSaved = await this.$refs.billingData.validateAndSaveForPayNow();
                }

                // 2. Walidacja danych billingowych (na aktualnym this.billingIdentity)
                this.verifyBillingData();

                // 3. Walidacja metody płatności
                const selectedPayment = this.payments.find(p => p.selected);
                if (!selectedPayment) {
                    this.orderErrors.payment_method = this.orderErrors.payment_method || [];
                    this.orderErrors.payment_method.push(this.$translate('checkout.select_payment_method'));
                } else if (selectedPayment.slug === 'PrepaidBalance') {
                    const prepaidPayment = this.payments.find(p => p.slug === 'PrepaidBalance');
                    const userBalance = prepaidPayment && typeof prepaidPayment.user_balance === 'number'
                        ? prepaidPayment.user_balance
                        : 0;
                    const needed = this.cartSummary && typeof this.cartSummary.promo_subtotal === 'number'
                        ? this.cartSummary.promo_subtotal
                        : 0;

                    if (userBalance < needed) {
                        this.orderErrors.payment_method = this.orderErrors.payment_method || [];
                        this.orderErrors.payment_method.push('<strong>' + this.$translate('checkout.payment_method') + ':</strong> ' + this.$translate('checkout.you_dont_have_sufficient_money_top_up_your_prepaid_balance'));
                    }
                }

                // 4. Komunikaty
                const hasOrderErrors = Object.keys(this.orderErrors).length > 0;

                if (!billingSaved || hasItemErrors || hasOrderErrors) {
                    this.items
                        .filter(item => item.associate === 'Domain')
                        .forEach(item => {
                            if (item.errors && typeof item.errors === 'object' && Object.keys(item.errors).length > 0) {
                                bus.emit('showDetails', item.rowId);
                            }
                        });

                    window.scrollTo(0, 0);

                    return;
                }

                if (!Array.isArray(this.items) || this.items.length === 0) {
                    ToastMessageDanger.emit(this.$translate('checkout.your_cart_is_empty'));

                    return;
                }

                // 5. Place order
                const response = await CheckoutAPI.placeOrder();

                this.order = response.order;

                this.sendGTMEvent('purchase', {
                    transaction_id: this.order.number
                });

                if (response.payment && response.payment.redirected) {
                    document.location.href = response.payment.redirect_url;
                    return;
                }

                this.orderPlaced = true;
                this.orderPaymentStatus = response.payment.status;
            } catch (responseError) {
                const status = responseError?.response?.status;
                const payload = responseError?.response?.data || {};

                const code = payload?.data?.code || null;

                const errors = payload?.message || null;

                if (status === 409 && code === 'EMPTY_CART') {
                    const msg = (errors?.cart && errors.cart[0]) ? errors.cart[0] : this.$translate('checkout.your_cart_is_empty');
                    ToastMessageDanger.emit(msg);

                    return;
                }

                if (status === 409 && code === 'ORDER_IN_PROGRESS') {
                    const msg = (errors?.cart && errors.cart[0]) ? errors.cart[0] : this.$translate('checkout.order_is_already_being_placed_please_wait');
                    ToastMessageDanger.emit(msg);

                    return;
                }

                if (errors) {
                    this.orderErrors = errors;
                }

                if (payload?.message) {
                    if (typeof payload.message === 'string') {
                        ToastMessageDanger.emit(payload.message);
                    } else if (typeof payload.message === 'object') {
                        for (const message of Object.values(payload.message)) {
                            if (Array.isArray(message)) {
                                ToastMessageDanger.emit(message.join(', '), 0);
                            }
                        }
                    }
                } else {
                    ToastMessageDanger.emit(this.$translate('domains.unexpected_error_occurred'));
                }
            } finally {
                this.placingOrder = false;
            }
        },
        hasRequirement(item, name) {
            const req = item.requirements;

            if (!req) {
                return false;
            }

            // jeśli tablica ['dob', 'dns', ...]
            if (Array.isArray(req)) {
                return req.includes(name);
            }

            // jeśli obiekt {dob: true, dns: true, ...}
            if (typeof req === 'object') {
                return !!req[name];
            }

            return false;
        },
        verifyIdentity(identity, additionalFields) {
            const errors = {};
            const i = identity || {};

            if (!i.address) {
                errors.address = this.$translate('validation.required', {attribute: this.$translate('auth.address_street')});
            }

            if (!i.district) {
                errors.district = this.$translate('validation.required', {attribute: this.$translate('auth.district')});
            }

            if (!i.postal_code) {
                errors.postal_code = this.$translate('validation.required', {attribute: this.$translate('auth.postal_code')});
            }

            if (!i.city) {
                errors.city = this.$translate('validation.required', {attribute: this.$translate('auth.city')});
            }

            if (!i.country_id) {
                errors.country_id = this.$translate('validation.required', {attribute: this.$translate('auth.country')});
            }

            if (!i.phone) {
                errors.phone = this.$translate('validation.required', {attribute: this.$translate('auth.phone')});
            }

            if (typeof additionalFields === 'object') {
                for (const [key, value] of Object.entries(additionalFields)) {
                    if (!i[key]) {
                        errors[key] = value;
                    }
                }
            }

            if (Object.keys(errors).length > 0) {
                return errors;
            }

            return true;
        },
        verifyDomainsRequirements() {
            let noErrors = true;

            this.items.filter(item => item.associate === 'Domain')
                .forEach(item => {
                    noErrors = this.verifyDomainRequirements(item) && noErrors;
                });

            return !noErrors;
        },
        verifyDomainRequirements(item, verifySection = null) {
            console.log('verifyDomainRequirements => ', item.name);
            item.errors = {};
            item.validated = true;

            const itemIdentity = this.getIdentityById(item.options.registrant_user_identity_id) || {};

            const additionalFields = {};

            // Firma = company_name + tax_id
            const isCompany =
                      !!(itemIdentity.company_name && itemIdentity.company_name.trim().length > 0) &&
                      !!(itemIdentity.tax_id && itemIdentity.tax_id.trim().length > 0);

            // Dodatkowe pola wymagamy TYLKO dla osób fizycznych
            if (!isCompany) {
                if (this.hasRequirement(item, 'dob')) {
                    additionalFields.dob = this.$translate('checkout.to_register_domains_please_provide_your_date_of_birth', {domains: item.name});
                }

                if (this.hasRequirement(item, 'pob')) {
                    additionalFields.pob = this.$translate('checkout.to_register_domains_please_provide_your_place_of_birth', {domains: item.name});
                }

                if (this.hasRequirement(item, 'id_number')) {
                    additionalFields.id_number = this.$translate('checkout.to_register_domains_please_provide_your_id_number', {domains: item.name});
                }
            }

            const registrantDataErrors = this.verifyIdentity(itemIdentity, additionalFields);

            if (typeof registrantDataErrors === 'object' && (!verifySection || verifySection === 'identity')) {
                item.errors['registrant_data'] = registrantDataErrors;
            }

            // Walidacja formatu daty urodzenia TYLKO dla osób fizycznych
            if (
                (!verifySection || verifySection === 'identity') &&
                !isCompany &&
                this.hasRequirement(item, 'dob') &&
                itemIdentity.dob
            ) {
                const dob = itemIdentity.dob;
                const regex = /^\d{4}-\d{2}-\d{2}$/;

                if (!regex.test(dob)) {
                    if (!item.errors.registrant_data) {
                        item.errors.registrant_data = {};
                    }

                    item.errors.registrant_data.dob = this.$translate('validation.date_of_birth_must_be_in_format', {
                        format: 'YYYY-MM-DD',
                        example_format: '1990-01-01'
                    });
                }
            }

            if (
                (!verifySection || verifySection === 'dns') &&
                this.hasRequirement(item, 'dns') &&
                (!item.options.user_dns_profile_id || item.options.user_dns_profile_id === null)
            ) {
                item.errors.dns = this.$translate('checkout.select_dns_profile');
            }

            if (
                (!verifySection || verifySection === 'restrictions') &&
                (item.restrictions || item.registrationInfo) &&
                (!item.options.restrictions_accepted || item.options.restrictions_accepted !== true)
            ) {
                item.errors.restrictions = this.$translate('checkout.please_confirm_registration_restrictions');
            }

            console.log('validation result = ', item.errors);

            return Object.keys(item.errors).length === 0;
        },
        getSelectedPayment() {
            return this.payments.find(payment => payment.selected);
        },
        getDomains() {
            return this.items.filter(item => item.associate === 'Domain');
        },
        getItemByRowId(rowId) {
            return this.items.find(item => item.rowId === rowId);
        },
        userIdentityExists(userIdentityId) {
            if (!userIdentityId) {
                return true; // Main identity
            }
            return this.identities.some(identity => identity.id === userIdentityId);
        },
        sendGTMEvent(eventName, additionalData = null) {
            if (!window.dataLayer) {
                return false;
            }

            let dataLayerItems = this.items.map(item => {
                return {
                    'item_id': item.rowId,
                    'item_name': item.name,
                    'currency': window.currency.iso4217,
                    'discount': Math.round((item.price - item.promoPrice) * 100) / 100,
                    'price': item.promoPrice,
                    'quantity': item.quantity
                }
            });

            let dataLayerObject = {
                event: eventName,
                currency: window.currency.iso4217,
                value: this.cartSummary.total,
                items: dataLayerItems
            };

            if (additionalData) {
                dataLayerObject = {...dataLayerObject, ...additionalData};
            }

            window.dataLayer.push(dataLayerObject);
        }
    },
    data() {
        return {
            cartSummary: null,
            dnsProfiles: [],
            items: [],
            identities: [],
            billingIdentityId: null,
            registrantIdentityId: null,
            useBillingForRegistrant: true,
            payments: [],
            savingBillingIdentity: false,
            cartItemsSaving: {},
            discountCode: {},
            ready: false,
            orderErrors: {},
            placingOrder: false,
            orderPlaced: false,
            order: {},
            orderPaymentStatus: true,
            cartUrl: '',
            checkoutUrl: '',
            frontendImgCartLoader,
            frontendImgCartEmpty,
            forceFirstAdd: false,
            manager: false,
            payNowExecuted: false
        }
    },
    computed: {
        fee() {
            return this.items.find(item => item.associate === 'PaymentCommission');
        },
        billingIdentity() {
            return this.identities.find(i => i.id === this.billingIdentityId) || null;
        },
        registrantIdentity() {
            if (this.useBillingForRegistrant) {
                return this.billingIdentity;
            }

            return this.identities.find(i => i.id === this.registrantIdentityId) || null;
        },
        hasAnyErrors() {
            const hasDomainErrors = this.items.some(
                item => item.associate === 'Domain'
                    && item.errors
                    && Object.keys(item.errors).length > 0
            );

            const hasOrderErrors = this.orderErrors && Object.keys(this.orderErrors).length > 0;

            return hasDomainErrors || hasOrderErrors;
        },
        hasDomainRegistrantErrors() {
            return this.items.some(
                item =>
                    item.associate === 'Domain' &&
                    item.errors &&
                    item.errors.registrant_data &&
                    Object.keys(item.errors.registrant_data).length > 0
            );
        },
        hasDomainDnsErrors() {
            return this.items.some(
                item =>
                    item.associate === 'Domain' &&
                    item.errors &&
                    !!item.errors.dns
            );
        },
        hasDomainRestrictionsErrors() {
            return this.items.some(
                item =>
                    item.associate === 'Domain' &&
                    item.errors &&
                    !!item.errors.restrictions
            );
        },
        hasBillingErrors() {
            return Array.isArray(this.orderErrors.billingData) && this.orderErrors.billingData.length > 0;
        },
        hasPaymentErrors() {
            return Array.isArray(this.orderErrors.payment_method) && this.orderErrors.payment_method.length > 0;
        }
    }
};
</script>
<template>
    <template v-if="!ready">
        <div class="container component-checkout">
            <div class="text-center loader-container">
                <img :src="frontendImgCartLoader">
                <div class="h2">{{ $translate('checkout.loading_checkout_data') }}</div>
            </div>
        </div>
    </template>
    <template v-if="ready && items.length === 0 && !orderPlaced">
        <div class="container component-checkout">
            <div class="cart-empty loader-container text-center">
                <img :src="frontendImgCartEmpty">
                <div class="h2">{{ $translate('checkout.your_cart_is_empty') }}</div>
            </div>
        </div>
    </template>
    <template v-if="ready && items.length > 0 && !orderPlaced">
        <div class="checkout-steps p-0 mt-4 mb-4 mb-md-6">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="steps">
                            <div class="step step-complete">
                                <i class="fa fa-check-circle"></i> <a :href="cartUrl">{{ $translate('checkout.cart') }}</a>
                            </div>
                            <div class="step step-current">
                                <i class="fa fa-chevron-circle-right"></i> {{ $translate('checkout.checkout') }}
                            </div>
                            <div class="step step-waiting">
                                <i class="fa fa-times-circle"></i> {{ $translate('checkout.complete') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container component-checkout" :class="{disabled: placingOrder}">
            <div class="row">
                <div class="col-lg-8">
                    <div
                        class="alert alert-danger alert-sm mt-2"
                        v-if="hasAnyErrors && payNowExecuted"
                    >
                        <p class="mb-1">
                            <strong>{{ $translate('checkout.checkout_first_view_alert_information_2') }}</strong>
                        </p>
                        <p class="mb-2">
                            {{ $translate('checkout.checkout_first_view_alert_information_3') }}
                        </p>

                        <ul class="mb-2 ps-3">
                            <li v-if="hasBillingErrors" class="mt-0" v-scrollto="'.component-billing-data'"
                                data-offset="20">
                                {{ $translate('checkout.billing_data') }}
                            </li>
                            <li v-if="hasPaymentErrors" class="mt-0" v-scrollto="'.component-payments'"
                                data-offset="20">
                                {{ $translate('checkout.payment_method') }}
                            </li>
                            <template v-for="item in getDomains()">
                                <li v-if="item.errors && Object.keys(item.errors).length > 0"
                                    v-scrollto="'.cart-item-domain[rid=\'' + item.rowId + '\']'" data-offset="20">
                                    Domain <strong>{{ item.name }}</strong>
                                    <ul>
                                        <li v-if="item.errors.registrant_data && Object.keys(item.errors.registrant_data).length > 0">
                                            {{ $translate('checkout.registrant_data') }}
                                        </li>
                                        <li v-if="item.errors.dns">{{ $translate('checkout.dns_profiles') }}</li>
                                        <li v-if="item.errors.restrictions">
                                            {{ $translate('checkout.domain_restrictions') }}
                                        </li>
                                    </ul>
                                </li>
                            </template>
                        </ul>

                        <p class="mb-0">
                            {{ $translate('checkout.checkout_first_view_alert_information_4') }}
                        </p>
                    </div>

                    <BillingData
                        ref="billingData"
                        :identities="identities"
                        :selected="billingIdentity"
                        :saving="savingBillingIdentity"
                        :errors="orderErrors.billingData"
                        @onSelected="setBillingIdentity"
                        @onEdited="onBillingEdited"
                    />
                    <Payments
                        :methods="payments"
                        :total="cartSummary.promo_total"
                        :subtotal="cartSummary.promo_subtotal"
                        :errors="orderErrors.payment_method"
                        :manager="manager"
                    />
                    <CartItems
                        :items="items"
                        :source="'Checkout'"
                        :identities="identities"
                        :saving="cartItemsSaving"
                        :dnsProfiles="dnsProfiles"
                    />
                </div>
                <div class="col-lg-4 position-relative">
                    <div class="sticky-element">
                        <CartSummary
                            :cartSummary="cartSummary"
                            :discountCode="discountCode"
                            :source="'Checkout'"
                            :placingOrder="placingOrder"
                            :manager="manager"
                            :fee="fee"
                            @PayNow="payNow"
                        />
                        <div
                            class="alert alert-info mt-2"
                            style="font-size: 0.85rem;"
                            v-if="forceFirstAdd && !hasAnyErrors"
                        >
                            <p class="mb-0">{{ $translate('checkout.checkout_first_view_information') }}</p>
                        </div>
                        <div
                            class="alert alert-info mt-2"
                            style="font-size: 0.85rem;"
                            v-if="!forceFirstAdd && !hasAnyErrors"
                        >
                            <p class="mb-0">{{ $translate('checkout.checkout_first_view_alert_information_1') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template v-if="ready && orderPlaced">
        <div class="checkout-steps p-0 mt-4 mb-6">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="steps">
                            <div class="step step-complete">
                                <i class="fa fa-check-circle"></i> <a :href="cartUrl">{{ $translate('checkout.cart') }}</a>
                            </div>
                            <div class="step step-complete">
                                <i class="fa fa-chevron-circle-right"></i> {{ $translate('checkout.checkout') }}
                            </div>
                            <div class="step step-current">
                                <i class="fa fa-chevron-circle-right"></i> {{ $translate('checkout.complete') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container component-checkout">
            <PaymentComplete
                :order="this.order"
                :payment="getSelectedPayment()"
                :order-payment-status="orderPaymentStatus"
            />
        </div>
    </template>
    <ModalsContainer></ModalsContainer>
    <div class="vue-toasts">
        <Toast></Toast>
    </div>
</template>
